import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import useDispatch from 'hooks/useDispatch'
import { selectCurrentMerchant } from 'selectors/merchant'
import { resetForm } from 'slices/Cms/Settings/ScannableCodes'

export const useScannableCodesFormInitialize = () => {
  const dispatch = useDispatch()
  const merchant = useSelector(selectCurrentMerchant)

  useEffect(() => {
    if (merchant) {
      dispatch(
        resetForm({
          instoreScanningEnabled: merchant.instore_scanning_enabled || false,
          supportsInstoreScanning: merchant.supports_instore_scanning || false,
        })
      )
    }
  }, [merchant, dispatch])
}
